/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData from './AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData';

/**
 * The AccountControllerDtoAccountInventoryInfoAccountInventoryCar model module.
 * @module model/AccountControllerDtoAccountInventoryInfoAccountInventoryCar
 * @version 1.0
 */
class AccountControllerDtoAccountInventoryInfoAccountInventoryCar {
    /**
     * Constructs a new <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCar</code>.
     * @alias module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCar
     */
    constructor() { 
        
        AccountControllerDtoAccountInventoryInfoAccountInventoryCar.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCar</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCar} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCar} The populated <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCar</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountInventoryInfoAccountInventoryCar();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('revealedAt')) {
                obj['revealedAt'] = ApiClient.convertToType(data['revealedAt'], 'Date');
            }
            if (data.hasOwnProperty('vehicleType')) {
                obj['vehicleType'] = ApiClient.convertToType(data['vehicleType'], 'Number');
            }
            if (data.hasOwnProperty('vehicleGrade')) {
                obj['vehicleGrade'] = ApiClient.convertToType(data['vehicleGrade'], 'Number');
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('sigil')) {
                obj['sigil'] = ApiClient.convertToType(data['sigil'], 'String');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('baseSpeed')) {
                obj['baseSpeed'] = ApiClient.convertToType(data['baseSpeed'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsSpeed')) {
                obj['extraStatsSpeed'] = ApiClient.convertToType(data['extraStatsSpeed'], 'Number');
            }
            if (data.hasOwnProperty('baseLuck')) {
                obj['baseLuck'] = ApiClient.convertToType(data['baseLuck'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsLucky')) {
                obj['extraStatsLucky'] = ApiClient.convertToType(data['extraStatsLucky'], 'Number');
            }
            if (data.hasOwnProperty('baseEnergy')) {
                obj['baseEnergy'] = ApiClient.convertToType(data['baseEnergy'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsEnergy')) {
                obj['extraStatsEnergy'] = ApiClient.convertToType(data['extraStatsEnergy'], 'Number');
            }
            if (data.hasOwnProperty('baseDurability')) {
                obj['baseDurability'] = ApiClient.convertToType(data['baseDurability'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsDurability')) {
                obj['extraStatsDurability'] = ApiClient.convertToType(data['extraStatsDurability'], 'Number');
            }
            if (data.hasOwnProperty('tempGemSocketColor')) {
                obj['tempGemSocketColor'] = ApiClient.convertToType(data['tempGemSocketColor'], 'String');
            }
            if (data.hasOwnProperty('tempGemSocket')) {
                obj['tempGemSocket'] = ApiClient.convertToType(data['tempGemSocket'], 'String');
            }
            if (data.hasOwnProperty('engineSocket')) {
                obj['engineSocket'] = ApiClient.convertToType(data['engineSocket'], 'Number');
            }
            if (data.hasOwnProperty('gemSockets')) {
                obj['gemSockets'] = ApiClient.convertToType(data['gemSockets'], [AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData]);
            }
            if (data.hasOwnProperty('condition')) {
                obj['condition'] = ApiClient.convertToType(data['condition'], 'Number');
            }
            if (data.hasOwnProperty('mileage')) {
                obj['mileage'] = ApiClient.convertToType(data['mileage'], 'Number');
            }
            if (data.hasOwnProperty('valid')) {
                obj['valid'] = ApiClient.convertToType(data['valid'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCar</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCar</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['sigil'] && !(typeof data['sigil'] === 'string' || data['sigil'] instanceof String)) {
            throw new Error("Expected the field `sigil` to be a primitive type in the JSON string but got " + data['sigil']);
        }
        // ensure the json data is a string
        if (data['tempGemSocketColor'] && !(typeof data['tempGemSocketColor'] === 'string' || data['tempGemSocketColor'] instanceof String)) {
            throw new Error("Expected the field `tempGemSocketColor` to be a primitive type in the JSON string but got " + data['tempGemSocketColor']);
        }
        // ensure the json data is a string
        if (data['tempGemSocket'] && !(typeof data['tempGemSocket'] === 'string' || data['tempGemSocket'] instanceof String)) {
            throw new Error("Expected the field `tempGemSocket` to be a primitive type in the JSON string but got " + data['tempGemSocket']);
        }
        if (data['gemSockets']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['gemSockets'])) {
                throw new Error("Expected the field `gemSockets` to be an array in the JSON data but got " + data['gemSockets']);
            }
            // validate the optional field `gemSockets` (array)
            for (const item of data['gemSockets']) {
                AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['nftUid'] = undefined;

/**
 * @member {Date} revealedAt
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['revealedAt'] = undefined;

/**
 * @member {Number} vehicleType
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['vehicleType'] = undefined;

/**
 * @member {Number} vehicleGrade
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['vehicleGrade'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['plusFlag'] = undefined;

/**
 * @member {String} sigil
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['sigil'] = undefined;

/**
 * @member {Number} level
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['level'] = undefined;

/**
 * @member {Number} baseSpeed
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['baseSpeed'] = undefined;

/**
 * @member {Number} extraStatsSpeed
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['extraStatsSpeed'] = undefined;

/**
 * @member {Number} baseLuck
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['baseLuck'] = undefined;

/**
 * @member {Number} extraStatsLucky
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['extraStatsLucky'] = undefined;

/**
 * @member {Number} baseEnergy
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['baseEnergy'] = undefined;

/**
 * @member {Number} extraStatsEnergy
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['extraStatsEnergy'] = undefined;

/**
 * @member {Number} baseDurability
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['baseDurability'] = undefined;

/**
 * @member {Number} extraStatsDurability
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['extraStatsDurability'] = undefined;

/**
 * @member {String} tempGemSocketColor
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['tempGemSocketColor'] = undefined;

/**
 * @member {String} tempGemSocket
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['tempGemSocket'] = undefined;

/**
 * @member {Number} engineSocket
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['engineSocket'] = undefined;

/**
 * @member {Array.<module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData>} gemSockets
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['gemSockets'] = undefined;

/**
 * @member {Number} condition
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['condition'] = undefined;

/**
 * @member {Number} mileage
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['mileage'] = undefined;

/**
 * @member {Boolean} valid
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCar.prototype['valid'] = undefined;






export default AccountControllerDtoAccountInventoryInfoAccountInventoryCar;

